import React, { useEffect, useRef, useState } from 'react'
import FormControl from '../../components/form/FormControl';
import { Button, Container, Form } from 'react-bootstrap';
import Logo from '../../components/ui/Logo';
import Footer from '../../components/ui/Footer';
import { createSearchParams, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Timestamp, addDoc, collection, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';
import FormSelect from '../../components/form/FormSelect';
import DateTimePicker from 'react-datetime-picker';

export default function CreateAppointment() {
  const { currentUser, userRole, userId } = useAuth();
    const serviceRef = useRef();
    const [startDate, onStartDateChange] = useState(new Date());
    const [services, setServices] = useState([]);
    const [appointment, setAppointment] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const servicesCollectionName = 'Services';
    const appointmentsCollectionName = "Appointments";

    

    useEffect(() => {
      if(!currentUser){
        navigate({
          pathname: '/login',
          search: createSearchParams({
              path: location.pathname
          }).toString()
        })
      }

      if(currentUser && userRole !== 'Admin'){
          navigate('/appointment-management');
      }

      const getServices = async () => {
        try{
            const data = await getDocs(collection(db, servicesCollectionName));

            setServices(data.docs.map((doc) => 
              ({ ...doc.data(), id: doc.id})));
          }catch(error){
              console.log("An Error Occured: ", error)
          }
      }

      const getAppointment = async () => {
        if(id){
            try{
                const docRef = doc(db, appointmentsCollectionName, id);
                const docSnap = await getDoc(docRef)
    
                if(docSnap.exists && (docSnap.data() !== null && docSnap.data() !== undefined)){
                  setAppointment({id: docSnap.id, ...docSnap.data()});
                  onStartDateChange(new Date(docSnap.data().start.seconds * 1000))
                }
              }catch(error){
                  console.log("An Error Occured: ", error, appointment.start, appointment)
              }
          }
      }

      getAppointment();
      getServices();
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try{
            setError('');
            setLoading(true);
        
            Date.prototype.addHours = function(h) {
              this.setTime(this.getTime() + (h*60*60*1000));
              return this;
            }

            var selectedService;
            
            services.forEach((service)=>{
              if(service.id === serviceRef.current.value)
                selectedService = service;
            })

            const endtime = new Date(startDate).addHours(selectedService.duration);

            console.log(selectedService, endtime)

            if(id){
              const docRef = doc(db, appointmentsCollectionName, id);
              await updateDoc(docRef, {
                title: selectedService.display_name,
                start:Timestamp.fromDate(new Date(startDate)),
                end:Timestamp.fromDate(endtime),
                user: currentUser.providerData[0],
                uid: userId,
                service: selectedService
              });

              navigate('/appointment-management');

            }else{
              const { id } = await addDoc(collection(db, appointmentsCollectionName), {
                title: selectedService.display_name,
                start:Timestamp.fromDate(new Date(startDate)),
                end:Timestamp.fromDate(endtime),
                user: currentUser.providerData[0],
                uid: userId,
                service: selectedService
              });

              navigate('/appointment-management');
            }

          } catch (e) {
            console.log(e)
            setError(e.message);
          }
        setLoading(false); 
    }
  return (
    <div>
        <Header>
          <h2 className='text-center text-dark thick-font sub-header-txt-shadow'>Create Appointment</h2>
        </Header>
        <Container>
          <Form className='row g-3 mb-3 text-dark thick-font' onSubmit={handleSubmit}>
            <Form.Group controlId="appointments">
              <FormSelect selection={appointment && appointment.service} list={services} ref={serviceRef} label={'Select Service'} classes ={"mb-3 col-sm-12 w-50 mx-auto"} ></FormSelect>
              <div className='col-xs-10 col-sm-8 col-md-6 mx-auto'>
                <Form.Label className='w-100'>Select Appointment Time</Form.Label>
                <DateTimePicker  className ={"mb-3 mx-auto form-control"} onChange={onStartDateChange} value={startDate} />
                <Button className='mt-2 mx-auto btn-lg btn-light bk-cream' type="submit">Submit Appointment</Button>
              </div>
            </Form.Group>
            
          </Form>
        </Container>
        <Footer />
    </div>
  )
}
